export const httpErrorCodes = {
  BAD_REQUEST: '400',
  UNAUTHORIZED: '401',
  FORBIDDEN: '403',
  NOT_FOUND: '404',
  UNPROCESSABLE_ENTITY: '422',
  METHOD_NOT_ALLOWED: '405',
  INTERNAL_SERVER_ERROR: '500',
  SERVICE_UNAVAILABLE: '503',
};
